// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a0b37246","879":"4bf43c18"}[chunkId] + ".chunk.js";
};